<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .divider {
    width: utils.in_rem(48px);
    $padding: utils.in_rem(8px);
    padding: $padding;
    position: relative;

    &.expanded {
      width: 100%;
    }

    svg {
      width: calc(100% - 2 * $padding);
      $height: utils.in_rem(2px);
      height: $height;
      position: absolute;
      top: calc(50% - $height / 2);
      left: $padding;

      > path {
        height: 100%;
        stroke: colors.get(interfaceTransparentWhite_30);
        stroke-width: utils.in_rem(1px);
      }
    }
  }
</style>

<script>
  import { sidebarIsExpanded } from "./stores/sidebar-store";
</script>

<div class="divider" class:expanded={$sidebarIsExpanded}>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none">
    <path d="M0.5 1H152.5" stroke-linecap="round" />
  </svg>
</div>
